var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlurStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 6,
    fill: "url(#paint0_linear_5104_624)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2996 13.5878L26.1327 17.2844C26.3827 17.799 27.0492 18.2926 27.6117 18.3871L30.9343 18.9436C33.059 19.3007 33.559 20.855 32.0279 22.3882L29.4449 24.9926C29.0074 25.4336 28.7679 26.2842 28.9032 26.8934L29.6428 30.1173C30.226 32.6692 28.8824 33.6564 26.6431 32.3227L23.5288 30.4639C22.9664 30.1279 22.0395 30.1279 21.4665 30.4639L18.3523 32.3227C16.1234 33.6564 14.7694 32.6587 15.3527 30.1173L16.0922 26.8934C16.2276 26.2842 15.988 25.4336 15.5506 24.9926L12.9675 22.3882C11.4469 20.855 11.9364 19.3007 14.0611 18.9436L17.3837 18.3871C17.9357 18.2926 18.6023 17.799 18.8523 17.2844L20.6854 13.5878C21.6853 11.582 23.3101 11.582 24.2996 13.5878Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5104_624",
    x1: 22.5,
    y1: -9.12696e-7,
    x2: 53.125,
    y2: 63.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0464B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022B4C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurStarIcon);
export default __webpack_public_path__ + "static/media/blurStarIcon.6711c0ca9a05da9b64b3073a2cfdade6.svg";
export { ForwardRef as ReactComponent };